import './../template/template.js'
import './style.min.css'

const donateButton = document.querySelector('#donate')

// Map enter key to button click
donateButton.addEventListener('keyup', (e) => {
    if (e.keyCode === 13) {
        document.querySelector('#donate-button').click()
    }
})
